import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

const CarouselItem = ({ title, shortDesc, linkToPost, image, alt, block }) => {
    const { t } = useTranslation();
    return (
        <li className="popup-container">
            <img className="popup-image" src={image} alt={alt} />
            <div className="popup-text">
                <h2 className='has-text-weight-bold	'>{title}</h2>
                <p>{shortDesc}</p>
                <Link className="button is-link is-small mt-5" to={`${block === 'agents' ? 'browse-agents' : 'browse-trips'}/${linkToPost}`}>
                    {t("MORE")}
                </Link>
            </div>
        </li>
    )
}

export default CarouselItem